import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Update Category Field',
  make: () => ({
    key: [],
    request: (fieldId: string, data: any) => async ({ http }) => {
      await http({
        method: 'PUT',
        route: `/fields/${fieldId}`,
        data,
      });
    },
  }),
});
